interface Rule {
  regex: RegExp
  replacement: string | ((match: string, ...args: string[]) => string)
}
export const rules: Rule[] = [
  {
    regex: /<p-button\s+([^>]+)>([^<]*?)<\/p-button>/g,
    replacement:
      '<div class="dynamic-component-placeholder" data-component="CustomButton" data-text="$2" data-attributes="$1"></div>',
  },
  {
    regex: /<p-link url="([^"]+)">([^"]+)<\/p-link>/g,
    replacement:
      '<div class="dynamic-component-placeholder" data-component="CustomLink" data-url="$1" data-text="$2"></div>',
  },
  {
    regex: /<p-select type="([^"]+)"><\/p-select>/g,
    replacement:
      '<div class="dynamic-component-placeholder" data-component="CustomSelect" data-type="$1"></div>',
  },
  { regex: /#### (.+)\n/g, replacement: '<h4>$1</h4>' },
  { regex: /### (.+)\n/g, replacement: '<h3>$1</h3>' },
  {
    regex: /(\n\s*- .+?)(?=\n\n)/gs,
    replacement: function (match: string) {
      const items = match
        .trim()
        .split('\n')
        .map((item) => {
          return item.replace(/^\s*-\s+(.+)$/, '<li>$1</li>')
        })
        .join('')
      return `<ul>${items}</ul>`
    },
  },
  {
    regex: /(\n\s*\d+\..+?)(?=\n\n(?!\d+))/gs,
    replacement: function (match: string) {
      const items = match
        .trim()
        .split('\n')
        .map((item) => {
          return item.replace(/^\s*(\d+)\.\s+(.+)$/, '<li>$2</li>')
        })
        .join('')
      return `<ol>${items}</ol>`
    },
  },
  { regex: /---/gm, replacement: '<hr>' },
  { regex: /<\/ol>\n\n/g, replacement: `</ol>` },
  { regex: /\n/g, replacement: `<br>` },
]

export const rulesText: Rule[] = [
  { regex: /\*\*\*(.+?)\*\*\*/gm, replacement: '<strong><em>$1</em></strong>' },
  { regex: /\*\*(.+?)\*\*/gm, replacement: '<strong>$1</strong>' },
  { regex: /\*(.+?)\*/gm, replacement: '<em>$1</em>' },
  { regex: /__(.+?)__/gm, replacement: '<u>$1</u>' },
]
